// extracted by mini-css-extract-plugin
export default {"MainCont":"Oven_MainCont__65ynn","LeftCont":"Oven_LeftCont__-+-ZO","RightCont":"Oven_RightCont__RZqgm"};